
import Picture from '~/components/picture/lole-picture.vue'
export default {
  components: { Picture },
  props: {
    banner: {
      type: Object,
      required: true,
    },
  },
  computed: {
    content() {
      return this?.banner?.banner
    },
  },
}
